import React from "react";
import { Spinner } from "../../utils/Spinner";
import { Option } from "../../components/tailwind/dropdown/Dropdown";
import { Dropdown } from "../../components/tailwind";

type Props = {
  fieldsetOptions: Option<number>[];
  selectedFieldset: number | null;
  onFieldsetChange: (id: number) => void;
  isValidating: boolean;
  validationError: string | null;
  disabled: boolean;
};

export const EnrichFieldsetSection: React.FC<Props> = ({
  fieldsetOptions,
  selectedFieldset,
  onFieldsetChange,
  isValidating,
  validationError,
  disabled,
}) => (
  <div className="tw-p-4">
    <div className="tw-flex tw-justify-between tw-items-start">
      <div>
        <p className="tw-text-lg tw-font-semibold tw-text-gray-900 tw-mb-0 tw-pb-0">
          Input Schema
        </p>
        <p className="tw-text-gray-500 tw-text-sm tw-mt-0 tw-pt-0">
          The Input Schema controls which fields will be enriched
        </p>
      </div>
    </div>
    <div className="tw-flex tw-items-start tw-gap-2 tw-mt-4">
      <div className="tw-flex-1">
        <Dropdown
          testIdBase="enrich-fieldset-dropdown"
          options={fieldsetOptions}
          value={selectedFieldset}
          onChange={(value) => onFieldsetChange(value as number)}
          placeholder="Select an Input Schema"
          disabled={disabled}
        />
      </div>
    </div>
    {isValidating && (
      <div className="tw-mt-4 tw-flex tw-justify-center tw-py-4">
        <Spinner />
      </div>
    )}
    {validationError && (
      <div className="tw-mt-4 tw-p-3 tw-bg-red-50 tw-text-red-700 tw-rounded tw-text-sm">
        {validationError}
      </div>
    )}
  </div>
);
